import mapboxgl from 'mapbox-gl';
import { Tool } from '@/types/tool';
import { createMapMarker } from './createMapMarker';
import { categoryColors } from '@/lib/constants';

export interface SerializableTool {
  id: string;
  name: string;
  description: string;
  logo: string;
  categories: string[];
  latitude: number;
  longitude: number;
  rating: number;
  reviews: number;
  pricing: string;
  visitUrl: string;
  dealUrl?: string;
  tags: string[];
  bookmarks: number;
  featured: boolean;
  business_phone?: string;
  address?: string;
}

export const createSerializableTool = (tool: Tool): SerializableTool => ({
  id: tool.id,
  name: tool.name,
  description: tool.description || '',
  logo: tool.logo,
  categories: tool.categories,
  latitude: tool.latitude!,
  longitude: tool.longitude!,
  rating: tool.rating,
  reviews: typeof tool.reviews === 'number' ? tool.reviews : 0,
  pricing: tool.pricing,
  visitUrl: tool.visitUrl,
  dealUrl: tool.dealUrl,
  tags: tool.tags,
  bookmarks: tool.bookmarks || 0,
  featured: tool.featured || false,
  business_phone: tool.business_phone,
  address: tool.address
});

export const setupMarkers = async (
  tools: Tool[],
  map: mapboxgl.Map
): Promise<mapboxgl.Marker[]> => {
  const markers: mapboxgl.Marker[] = [];

  for (const tool of tools) {
    if (tool.latitude && tool.longitude) {
      try {
        const serializableTool = createSerializableTool(tool);
        const marker = await createMapMarker({ 
          tool: serializableTool,
          map, 
          color: categoryColors[tool.categories[0]] || '#000000'
        });
        markers.push(marker);
      } catch (error) {
        console.warn('Error creating marker:', error);
      }
    }
  }

  return markers;
};

export const addSelectedLocationMarker = (
  map: mapboxgl.Map,
  lat: number,
  lng: number
): mapboxgl.Marker => {
  return new mapboxgl.Marker({ 
    color: '#FF0000',
    scale: 0.9,
  })
    .setLngLat([lng, lat])
    .addTo(map);
};